
  import { Vue, Component, Prop , Emit } from "vue-property-decorator";
  import UiButtonMessage from "@/components/button/ui-button-message.vue";
  import AddNotesModal from "@/components/common/AddNotesModal.vue";
  import PlusIcon from "@/components/icons/PlusIcon.vue";

  @Component({
    components: {
      UiButtonMessage,
      AddNotesModal,
      PlusIcon,
    },
  })

  export default class AddNotesToContractorsNew extends Vue {
    @Prop({ type: String, default: undefined }) readonly buttonSize?: string;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, required: true }) readonly contractorId!: string;
    @Prop({ type: String, required: true }) readonly contractorUserId!: string;

    

    editModal: boolean = false
    modalShown: boolean = false


    showEdit(): void {
      this.editModal = true
    }

    showModal(): void {
      this.modalShown = true;
    }

    closeModal(): void {
      this.modalShown = false;
    }

    closeEdit(): void {
      this.editModal = false
    }

     noteAddedToContractor(): void {
      this.closeModal();
      this.$emit("noteWasAddedToContractor");
    }

    async addNotesToContractors(): Promise<void> {
      this.noteAddedToContractor()
    }
  }
